import { Transition } from "@headlessui/react";

export default function SlideInAnimation({
    children,
    className,
    as = "div",
    appear = false,
    show = true,
    scrollAfterRender = true,
}) {
    function scrollToBottom() {
        if (!scrollAfterRender) return;
        const container = document.getElementById("rightColumn");
        container?.scrollTo({
            left: 0,
            top: container.scrollHeight,
            behavior: "smooth",
        });
    }

    return (
        <>
            <Transition
                as={as}
                appear={appear} //THIS will make the transition run everytime the component is rendered
                show={show}
                enter="transition-all duration-300"
                enterFrom="transform translate-x-full"
                enterTo=""
                leave="transition-all duration-300"
                leaveFrom="transform translate-x-0"
                leaveTo="transform translate-x-full"
                beforeEnter={scrollToBottom}
                afterEnter={scrollToBottom}
                className={className}
            >
                {show && children}
            </Transition>
        </>
    );
}
